import { BaseModel } from 'projects/core/src/lib/models/base.model';

export class MarkModel extends BaseModel {

  // properties
  candidate_id: number; // tslint:disable-line: variable-name
  element_id: number; // tslint:disable-line: variable-name
  chapter: string;
  uuid: string;
  start: number;
  end: number;
  color: string;
  notices: string;

  // client
  layers: Array<MarkLayerModel>;

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }

}

export class MarkLayerModel {
  top: number;
  left: number;
  width: number;
  height: number;
  color: string;
  notices: string;
  visible: boolean;
}
